import { BrowserRouter, Routes, Route, Outlet } from 'react-router';
import { QueryProvider } from '@/providers/QueryProvider';
import { GhAuthProvider } from '@/providers/GhAuthProvider';
import { Toaster } from 'sonner';
import { Layout } from '@/components/Layout';
import { AdProvider } from '@/ads';
import { ImagePathProvider } from '@/providers/ImagePathProvider';
import { IS_NATIVE } from '@/lib/nativeBridge';
import NotFound from '@/pages/NotFound';
import { LeaderboardPage } from './pages/Leaderboard';
import { TeamPage } from './pages/Teams';
import { MyTeamPage } from './pages/Teams/my-team';
import { MyTeamHistoryPage } from './pages/Teams/history';
import MyLeagues from './pages/MyLeagues/MyLeagues';
import LeagueDetail from './pages/LeagueDetail/LeagueDetail';
import JoinLeagueByLink from './pages/JoinLeagueByLink/JoinLeagueByLink';
import JoinLeague from './pages/JoinLeague/JoinLeague';
import CreateLeague from './pages/CreateLeague/CreateLeague';
import { MatchCenter } from './pages/MatchCenter';
import MatchDetail from './pages/MatchDetail';
import { StatsCentre } from './pages/StatsCentre';
import { HowToPlay } from './pages/HowToPlay';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import PlayerProfile from './pages/PlayerProfile/PlayerProfile';
import { DevQaOverlay } from '@/components/DevQaOverlay';
import { TeamEntryBootstrapGate } from '@/components/TeamEntryBootstrapGate';
import { AnalyticsProvider } from '@/analytics';
import { GamingHubAuthHost } from '@/components/DreShell';

function AppRoutes() {
  return (
    <GhAuthProvider>
      <AnalyticsProvider>
        <AdProvider adsEnabled={!IS_NATIVE}>
          <Routes>
            <Route element={<TeamEntryBootstrapGate />}>
              <Route
                element={
                  <Layout>
                    <Outlet />
                  </Layout>
                }
              >
                <Route index element={<TeamPage />} />
                <Route path="my-team" element={<Outlet />}>
                  <Route index element={<MyTeamPage />} />
                  <Route path="history" element={<MyTeamHistoryPage />} />
                </Route>
              </Route>
            </Route>
            <Route
              path="/leagues"
              element={
                <ProtectedRoute>
                  <Layout>
                    <MyLeagues />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/leagues/join"
              element={
                <ProtectedRoute>
                  <Layout>
                    <JoinLeague />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/leagues/create"
              element={
                <ProtectedRoute>
                  <Layout>
                    <CreateLeague />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/leagues/join/:code"
              element={
                <Layout>
                  <JoinLeagueByLink />
                </Layout>
              }
            />
            <Route
              path="/leagues/:leagueId"
              element={
                <ProtectedRoute>
                  <Layout>
                    <LeagueDetail />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/leaderboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <LeaderboardPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/match-centre"
              element={
                <ProtectedRoute>
                  <Layout>
                    <MatchCenter />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/player/:playerId"
              element={
                // <ProtectedRoute>
                <Layout>
                  <PlayerProfile />
                </Layout>
                // </ProtectedRoute>
              }
            />
            <Route
              path="/match/:matchId"
              element={
                <ProtectedRoute>
                  <Layout>
                    <MatchDetail />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stats-centre"
              element={
                <ProtectedRoute>
                  <Layout>
                    <StatsCentre />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/how-to-play"
              element={
                <Layout>
                  <HowToPlay />
                </Layout>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AdProvider>
      </AnalyticsProvider>
    </GhAuthProvider>
  );
}

export default function App() {
  return (
    <QueryProvider>
      <ImagePathProvider>
        <GamingHubAuthHost />
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <DevQaOverlay />
      </ImagePathProvider>
      <Toaster />
    </QueryProvider>
  );
}
